import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import Modal from 'react-modal'

export const ModalComponent = styled(Modal).attrs({
  style: {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 120,
    },
  },
})`
  position: absolute;
  top: ${({ isLarge }: any) => (isLarge ? '5%' : '20%')};
  left: ${({ isLarge }: any) => (isLarge ? '5%' : '20%')};
  right: ${({ isLarge }: any) => (isLarge ? '5%' : '20%')};
  bottom: ${({ isLarge }: any) => (isLarge ? '5%' : '20%')};
  max-width: ${({ maxWidth, isLarge }: any) => (isLarge ? '90%' : `${maxWidth || 500}px`)};
  padding: 25px;
  height: fit-content;
  overflow-y: auto;
  border-radius: 10px;
  background: #fff;
  margin: auto;
  max-height: 100%;
  ${down('md')} {
    width: 100%;
    top: 0%;
    left: 0%;
    right: 0%;
    bottom: 0%;
  }
`
export const Content = styled.div<{ maxWidth?: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 15px;
  svg {
    cursor: pointer;
  }
  img {
    cursor: pointer;
  }
`
export const ContentBody = styled.div`
  overflow-y: auto;
  max-height: 800px;
`

export const TitleHeader = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.title};
`
